import React from 'react';
import { IconArrowDown, IconArrowsVertical, IconArrowUp } from '@tabler/icons-react';

import { convertValueTo2DP } from 'helpers';

const PercentChangeBox = (props) => {
  const { percent_change } = props;
  return (
    <strong className={`number ${percent_change < 0 ? 'fails' : percent_change > 0 ? 'success' : 'zero'}`}>
      {percent_change < 0 ? (
        <IconArrowDown stroke={1.5} />
      ) : percent_change > 0 ? (
        <IconArrowUp stroke={1.5} />
      ) : (
        <IconArrowsVertical stroke={1.5} />
      )}
      {convertValueTo2DP(percent_change)}%
    </strong>
  );
};

export default PercentChangeBox;
